// frontend/src/components/parts/PartStatusFlow.js
// Part-specific wrapper around the shared status flow panel.
import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress } from '@mui/material';

import StatusFlowPanel from '../common/StatusFlowPanel';
import {
    getPart, setPartStatus, decidePart, getPartHistory,
} from '../../services/endpoints';

const PartStatusFlow = ({ part, onStatusUpdate, onTaskUpdate, onClose }) => {
    // Re-fetch so allowed_next reflects the server's view of the flow.
    const [current, setCurrent] = useState(part);
    const [loading, setLoading] = useState(true);

    const reload = React.useCallback(async () => {
        if (!part?.id) return;
        try {
            const res = await getPart(part.id);
            setCurrent(res.data);
        } catch {
            setCurrent(part);
        } finally {
            setLoading(false);
        }
    }, [part]);

    useEffect(() => { reload(); }, [reload]);

    if (loading && !current) {
        return (
            <Box sx={{ py: 4, display: 'grid', placeItems: 'center' }}>
                <CircularProgress />
            </Box>
        );
    }

    const handleDone = () => {
        reload();
        onStatusUpdate?.();
        onTaskUpdate?.();
    };

    return (
        <Box>
            <StatusFlowPanel
                item={current}
                label="Part"
                onSetStatus={(body) => setPartStatus(part.id, body)}
                onDecide={(body) => decidePart(part.id, body)}
                onLoadHistory={() => getPartHistory(part.id).then(r => r.data)}
                onDone={handleDone}
            />
            {onClose && (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Button onClick={onClose}>Close</Button>
                </Box>
            )}
        </Box>
    );
};

export default PartStatusFlow;
